import { DirectiveBinding, App } from "vue";
import { AppModule } from "@/core/store/modules/app-module";

function $feature(action: string): string | null {
  if (!AppModule.config.features) return null;
  const features = AppModule.config.features.values as { [key: string]: string };
  return features[action] ?? null;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-unused-vars
function FeatureDirective(app: App, options?: any): void {
  app.config.globalProperties.$feature = (action: string): string | null => {
    return $feature(action);
  };
  app.directive("feature", {
    mounted: (el: HTMLElement, binding: DirectiveBinding) => {
      const featureKey = binding.value;
      const featureValue = $feature(featureKey);

      if (!featureValue) {
        el.remove();
      }

      if (binding.modifiers["bool"] && featureValue == "false") {
        el.remove();
      }

      const key = Object.keys(binding.modifiers).join(".");
      if ($feature(key)) {
        el.remove();
      }
    }
  });
}

function FeatureGuard(feature: string): string | null {
  return $feature(feature);
}

export { FeatureDirective, FeatureGuard };
